<script setup lang="ts">
import ProfileCard from '@/components/profileMenu/ProfileCard.vue'
import ProfileAvatar from '@/components/profileMenu/ProfileAvatar.vue'

import {
  DropdownMenuContent,
  DropdownMenuPortal,
  DropdownMenuRoot,
  DropdownMenuTrigger
} from 'radix-vue'
import { inject, type HTMLAttributes } from 'vue'
import { usePlayerStats } from '@/composables/usePlayerStats'

const logOut = inject('logOut')

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()

const { rankData } = usePlayerStats()
</script>

<template>
  <DropdownMenuRoot>
    <DropdownMenuTrigger>
      <profile-avatar :rank="rankData.rank" />
    </DropdownMenuTrigger>
    <DropdownMenuPortal>
      <DropdownMenuContent
        side="bottom"
        :align="'center'"
        class="outline-hidden bg-light-grey z-[999] mr-2 w-[97vw] max-w-[500px] rounded-xl p-1 transition-all will-change-[opacity,transform] data-[side=bottom]:animate-slideUpAndFade md:mr-10"
      >
        <ProfileCard
          :rank="rankData.rank"
          :rankTitle="rankData.rankTitle"
          :score="rankData.score"
          :rankMax="rankData.rankMax"
          @logOut="logOut"
        />
      </DropdownMenuContent>
    </DropdownMenuPortal>
  </DropdownMenuRoot>
</template>
